var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-tree',{ref:"tree",staticClass:"filter-tree",attrs:{"data":_vm.data,"highlight-current":true,"node-key":"group_id","props":_vm.defaultProps,"default-expand-all":""},on:{"node-click":_vm.nodeClick}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }